// MobileMenu.jsx - Mobile navigation drawer
import React from 'react';
import { Link } from 'react-router-dom';
import { X, Home, ShoppingBag, Paintbrush, Mail, Truck, RefreshCw, FileText, Shield } from 'lucide-react';
import './MobileMenu.css';
import useDialogFocus from '../utils/useDialogFocus';

const MobileMenu = ({ isOpen, onClose, navLinks, currentPath, onShopClick }) => {
  const dialogRef = useDialogFocus(isOpen, onClose);

  // Get icon for nav link
  const getNavIcon = (path) => {
    switch (path) {
      case '/':
        return <Home size={20} />;
      case '/?section=shop':
        return <ShoppingBag size={20} />;
      case '/custom-orders':
        return <Paintbrush size={20} />;
      case '/contact':
        return <Mail size={20} />;
      default:
        return null;
    }
  };

  // Secondary links for policies
  const secondaryLinks = [
    { path: '/shipping', label: 'Shipping Info', icon: <Truck size={18} /> },
    { path: '/returns', label: 'Returns Policy', icon: <RefreshCw size={18} /> },
    { path: '/terms', label: 'Terms of Service', icon: <FileText size={18} /> },
    { path: '/privacy', label: 'Privacy Policy', icon: <Shield size={18} /> }
  ];

  const handleLinkClick = (e, path) => {
    if (path === '/?section=shop') {
      onShopClick(e);
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="mobile-menu-overlay"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Drawer */}
      <div className="mobile-menu-drawer" ref={dialogRef} role="dialog" aria-modal="true" aria-label="Site navigation">
        {/* Header */}
        <div className="mobile-menu-header">
          <div className="mobile-menu-brand">
            <img src="/brand-monogram.svg" alt="" aria-hidden="true" className="mobile-menu-logo" width="48" height="37" />
            <span className="mobile-menu-title">Two Gs Crafting</span>
          </div>
          <button
            className="mobile-menu-close"
            onClick={onClose}
            aria-label="Close menu"
          >
            <X size={24} />
          </button>
        </div>

        {/* Main Navigation */}
        <nav className="mobile-menu-nav">
          <div className="nav-section">
            <h3 className="nav-section-title">Menu</h3>
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`mobile-nav-link ${currentPath === link.path ? 'active' : ''}`}
                onClick={(e) => handleLinkClick(e, link.path)}
              >
                {getNavIcon(link.path)}
                <span>{link.label}</span>
              </Link>
            ))}
          </div>

          {/* Secondary Links */}
          <div className="nav-section">
            <h3 className="nav-section-title">Information</h3>
            {secondaryLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`mobile-nav-link secondary ${currentPath === link.path ? 'active' : ''}`}
                onClick={onClose}
              >
                {link.icon}
                <span>{link.label}</span>
              </Link>
            ))}
          </div>
        </nav>

        {/* Footer */}
        <div className="mobile-menu-footer">
          <div className="contact-info">
            <p className="contact-label">Need help?</p>
            <a href="https://wa.me/27650717182" className="whatsapp-link">
              WhatsApp: 065 071 7182
            </a>
          </div>
          <p className="copyright">
            &copy; {new Date().getFullYear()} Two Gs Crafting
          </p>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
